<app-content-container data-testid="admin-user-feedback">
  <app-banner-card
    [header]="'pages.admin.userFeedback.banner.title' | translate"
    [headerHeight]="44"
    [breadcrumbs]="breadcrumbs"
  />

  <div class="flex flex-col">
    <form
      class="flex custom-form flex-wrap items-center gap-4"
      data-testid="admin-user-feedback-search-form"
      (ngSubmit)="onSearchClick()"
    >
      <mat-form-field class="!min-w-80">
        <mat-label>{{ 'shared.bugReport.type' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedTypes" name="selectedTypes" multiple>
          @for (type of typeOptions; track type) {
            <mat-option [value]="type">
              {{ 'shared.userFeedbackTypes.' + (type | lowercase) | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field class="!min-w-80">
        <mat-label>{{ 'shared.status' | translate }}</mat-label>
        <mat-select [(ngModel)]="selectedStatuses" name="selectedStatuses" multiple>
          @for (status of statusOptions; track status) {
            <mat-option [value]="status">
              {{ 'shared.userFeedbackStatuses.' + (status | lowercase) | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (userGroupStore.userGroups$()) {
        <mat-form-field class="!min-w-80">
          <mat-label>{{ 'shared.userGroupId' | translate }}</mat-label>
          <mat-select
            [placeholder]="'shared.all' | translate"
            [multiple]="true"
            (selectionChange)="onUserGroupChange($event.value)"
          >
            @for (opt of userGroupStore.userGroups$(); track opt.id) {
              <mat-option [value]="opt.id">{{ opt.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      } @else {
        <ngx-skeleton-loader class="w-80 h-12" [theme]="{ width: '320px', height: '48px', 'border-radius': '100vw' }" />
      }

      <button
        mat-flat-button
        color="primary"
        type="submit"
        data-testid="admin-user-feedback-search-button"
        [disabled]="store.loading$()"
      >
        @if (store.loading$()) {
          <app-dots-spinner />
        } @else {
          {{ 'shared.search' | translate }}
        }
      </button>
      <hr class="w-full mt-2 mb-6" />
    </form>

    @if (searchedOnce()) {
      @if (hasResults() || store.loading$()) {
        <app-datatable
          data-testid="admin-user-feedback-datatable"
          [rowData]="rowData()"
          [columns]="datatableColumns"
          [configurationInput]="datatableConfig"
          [customColumnDef]="[
            { name: 'actions', isSortable: false, template: actionsColumn },
            { name: 'createdAt', isSortable: true, template: createdAtColumn },
            { name: 'message', isSortable: true, template: messageColumn },
            { name: 'status', isSortable: true, template: statusColumn },
            { name: 'type', isSortable: true, template: typeColumn },
            { name: 'userGroupId', isSortable: true, template: userGroupIdColumn },
          ]"
          [total]="total()"
          [loaderConfig]="loaderConfig"
          [isInitialDataLoaded]="searchedOnce() && store.userFeedback$() !== null"
          [loadingData]="store.loading$()"
          (rowClick)="onRowClick($event.row)"
        />

        <ng-template #createdAtColumn let-row="row">
          <span>{{ row.createdAtDate ? (row.createdAtDate | date: 'dd.MM.yyyy HH:mm') : '-' }}</span>
        </ng-template>

        <ng-template #messageColumn let-row="row">
          <span
            matTooltip
            matTooltipPosition="above"
            class="line-clamp-2 text-ellipsis"
            [appTextClampTooltip]="row.message"
          >
            {{ row.message?.trim() ?? '-' }}
          </span>
        </ng-template>

        <ng-template #statusColumn let-row="row">
          <span>{{ 'shared.userFeedbackStatuses.' + (row.status | lowercase) | translate }}</span>
        </ng-template>

        <ng-template #typeColumn let-row="row">
          <span>{{ 'shared.userFeedbackTypes.' + (row.type | lowercase) | translate }}</span>
        </ng-template>

        <ng-template #userGroupIdColumn let-row="row">
          <span>{{ row.userGroupId ?? '-' }}</span>
        </ng-template>

        <ng-template #actionsColumn let-row="row">
          <div *hasPermission="[EPermissions.userFeedbackUpdateAll]" class="flex items-center justify-start">
            <button
              mat-icon-button
              class="mat-secondary-transparent-button-color"
              [matMenuTriggerFor]="menu"
              (click)="$event.stopPropagation()"
            >
              <app-icon src="/icons/three-dots.svg" alt="More" [size]="16" />
            </button>
            <mat-menu #menu="matMenu">
              @for (status of statusOptions; track status) {
                @if (status?.toLowerCase() !== row.status?.toLowerCase()) {
                  <button mat-menu-item (click)="onStatusSelect($event, row, status)">
                    <span>
                      {{
                        'pages.admin.userFeedback.moveTo'
                          | translate: { status: 'shared.userFeedbackStatuses.' + (status | lowercase) | translate }
                      }}
                    </span>
                  </button>
                }
              }
            </mat-menu>
          </div>
        </ng-template>
      } @else if (showEmptyState()) {
        <div class="py-16 text-center text-sm text-gray-500" data-testid="admin-user-feedback-empty-state">
          {{ 'shared.noResults' | translate }}
        </div>
      }
    }
  </div>
</app-content-container>
